"use client";

import { c as _c } from "react/compiler-runtime";
import { useInstantSearch } from "react-instantsearch";
import { Button } from "@/components/ui/button";
import { PRODUCTS_INDEX_NAME } from "@/lib/search/instantsearchClient";
import { ALL_FACETS } from "@/lib/search/queryConfig";
interface Props {
  onClose: () => void;
}

// Mobile drawer actions. Filters auto-apply live as the user toggles them, so
// Apply is a pure facade that just closes the drawer. Clear All wipes every
// facet immediately (drawer stays open) via setUiState, mirroring the pill
// bar's handleClearAll — preserving `query` and dropping all ALL_FACETS keys.
export function PlpDrawerFilterActions(t0) {
  const $ = _c(9);
  const {
    onClose
  } = t0;
  const {
    setUiState
  } = useInstantSearch();
  let t1;
  if ($[0] !== setUiState) {
    t1 = function clearAll() {
      setUiState(_temp);
    };
    $[0] = setUiState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const clearAll = t1;
  let t2;
  if ($[2] !== onClose) {
    t2 = <Button className="h-9" onClick={onClose}>Apply</Button>;
    $[2] = onClose;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== clearAll) {
    t3 = <Button variant="outline" className="h-9" onClick={clearAll}>Clear All</Button>;
    $[4] = clearAll;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex justify-end gap-3">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(prev) {
  const indexState = prev[PRODUCTS_INDEX_NAME] ?? {};
  const refinementList = {
    ...(indexState.refinementList ?? {})
  };
  for (const facet of ALL_FACETS) {
    delete refinementList[facet];
  }
  return {
    ...prev,
    [PRODUCTS_INDEX_NAME]: {
      ...indexState,
      refinementList
    }
  };
}